import { getAPI } from "../../../../api/Networking";
import { LabelValue } from "../../../../models/Dashboard/Analytics";
import { DashboardAPIFilters } from "../../../../models/Dashboard/DashboardFilters";

export default class DashboardAnalyticsAPI {
  getChurnTats = async (
    url: string,
    filters: DashboardAPIFilters
  ): Promise<LabelValue[]> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.start_date)
        queryParams.append("start_date", filters.start_date);
      if (filters.end_date) queryParams.append("end_date", filters.end_date);
      if (filters.date) queryParams.append("date", filters.date);
      if (filters.poc_ids && filters.poc_ids.length > 0) {
        queryParams.append(
          "poc_ids",
          filters.poc_ids.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/dashboard-analytics/${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
